import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-559b9d53"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { useRoute, useRouter } from 'vue-router'
import { computed, inject, onMounted, ref, watch } from 'vue'

import { useStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  props: {
    rng: null
  },
  setup(__props: any) {

const props = __props as {
  rng: number
};



const i = ref(0)
const emitter = inject<any>('emitter')

const logos = Array.from(Array(9).keys()).map((i) => `/logos/logo${i + 1}.png`)

const computedLogo = computed(() => {
  // eslint-disable-next-line no-unused-expressions
  props.rng
  // eslint-disable-next-line no-unused-expressions
  i.value

  const index = Math.floor(Math.random() * logos.length)
  return logos[index]
})

const route = useRoute()
const store = useStore()
const router = useRouter()

const isFrontPage = computed(() => route.path === '/')

const nav = () => {
  router.push('/')
  emitter.emit('close.modal')
  store.menuOpened = false
}

const win = window
const ww = win.innerWidth
const wh = win.innerHeight

let box: HTMLElement | null = null
let boxWidth = 0
let boxHeight = 0
let boxTop = 0
let boxLeft = 0
let xMin = 0
let yMin = 0
let xMax = 0
let yMax = 0

let translateX = Math.floor(Math.random() * ww + 1)
let translateY = Math.floor(Math.random() * wh + 1)
let request = null
let direction = 'se'
const speed = 1
let timeout: any = null

function setValues() {
  box = document.getElementById('logo')
  boxWidth = box?.clientWidth || 0
  boxHeight = box?.clientHeight || 0
  boxTop = box?.offsetTop || 0
  boxLeft = box?.offsetLeft || 0
  xMin = -boxLeft
  yMin = -boxTop
  xMax = win.innerWidth - boxLeft - boxWidth
  yMax = win.innerHeight - boxTop - boxHeight

  // console.log('box', box)
  // console.log('boxWidth', boxWidth)
  // console.log('boxHeight', boxHeight)
  // console.log('boxTop', boxTop)
  // console.log('boxLeft', boxLeft)
}

onMounted(() => {
  setValues()
  init()
})

// reset constraints on resize
window.addEventListener(
  'resize',
  (argument) => {
    clearTimeout(timeout)
    timeout = setTimeout(update, 100)
    setValues()
  },
  false
)

function init() {
  request = requestAnimationFrame(init)
  move()
}

// reset constraints
function update() {
  xMin = -boxLeft
  yMin = -boxTop
  xMax = win.innerWidth - boxLeft - boxWidth
  yMax = win.innerHeight - boxTop - boxHeight
}

function move() {
  if (!box || isFrontPage.value) return

  setDirection()
  setStyle(box, {
    transform: `translate3d(${translateX}px, ${translateY}px, 0)`,
  })
}

function setDirection() {
  switch (direction) {
    case 'ne':
      translateX += speed
      translateY -= speed
      break
    case 'nw':
      translateX -= speed
      translateY -= speed
      break
    case 'se':
      translateX += speed
      translateY += speed
      break
    case 'sw':
      translateX -= speed
      translateY += speed
      break
  }
  setLimits()
}

function setLimits() {
  if (translateY <= yMin) {
    if (direction === 'nw') direction = 'sw'
    else if (direction === 'ne') direction = 'se'

    i.value++
    i.value++
  }
  if (translateY >= yMax) {
    if (direction === 'se') direction = 'ne'
    else if (direction === 'sw') direction = 'nw'

    i.value++
    i.value++
  }
  if (translateX <= xMin) {
    if (direction === 'nw') direction = 'ne'
    else if (direction === 'sw') direction = 'se'

    i.value++
    i.value++
  }
  if (translateX >= xMax) {
    if (direction === 'ne') direction = 'nw'
    else if (direction === 'se') direction = 'sw'

    // i.value++
    // i.value++
  }
}

watch([i, isFrontPage], async () => {
  await new Promise((resolve) => setTimeout(resolve, 33))
  setValues()
})

function getVendor() {
  const ua = navigator.userAgent.toLowerCase()
  const match = (/opera/.exec(ua) ||
    /msie/.exec(ua) ||
    /firefox/.exec(ua) ||
    /(chrome|safari)/.exec(ua) ||
    /trident/.exec(ua))?.[0]

  const vendors: Record<string, string> = {
    opera: '-o-',
    chrome: '-webkit-',
    safari: '-webkit-',
    firefox: '-moz-',
    trident: '-ms-',
    msie: '-ms-',
  }

  if (!match) return vendors.safari

  return vendors[match]
}

function setStyle(element: HTMLElement, properties: Record<string, any>) {
  const prefix = getVendor()
  let property
  let css = ''
  for (property in properties) {
    css += `${property}: ${properties[property]};`
    css += `${prefix + property}: ${properties[property]};`
  }
  element.style.cssText += css
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "logo",
    class: _normalizeClass(["logo", { 'is-opened': _unref(store).menuOpened, 'is-inverted': _unref(store).menuInverted }])
  }, [
    _createElementVNode("img", {
      src: _unref(computedLogo),
      onClick: nav
    }, null, 8, _hoisted_1)
  ], 2)), [
    [_vShow, !_unref(isFrontPage)]
  ])
}
}

})